import anime from 'animejs';
import { animationOnIntersection } from '../functions';

export default class ArrowAnimation {
  constructor($arrow) {
    this.$arrow = $arrow;
    this.animation = this.createAnimation();

    animationOnIntersection(this.$arrow, this.animation);
  }

  createAnimation() {
    return anime({
      targets: this.$arrow,
      translateY: ['-3rem', 0],
      opacity: [0, 1],
      delay: 1000,
      autoplay: false,
      duration: 500,
      easing: 'easeInOutQuart',
    });
  }
}


// WEBPACK FOOTER //
// ./scripts/animation/ArrowAnimation.js